export const commonStyles = (FOUNDATIONS, FONT) => ({
    link: {
        text_decoration: 'underline',
        font_size: FOUNDATIONS.font_size_paragraph_small,
        color: FOUNDATIONS.color_comp_navigation_breadcrumbs_default_font,
    },
    iconDivider: {
        color: FOUNDATIONS.color_comp_navigation_breadcrumbs_default_icon,
        width: FOUNDATIONS.size_75,
        height: FOUNDATIONS.size_125,
    },
    iconDividerContainer: {
        margin_left: FOUNDATIONS.spacing_100,
        margin_right: FOUNDATIONS.spacing_100,
    },
    lastOneCrumb: {
        color: FOUNDATIONS.color_exception_neutral_font_350,
        font_size: FOUNDATIONS.font_size_paragraph_small,
        text_decoration: 'none',
    },
});
//# sourceMappingURL=commonStyles.js.map